import React, { useEffect, useRef } from 'react';
import L from 'leaflet';

export function OrderMap({ order, driver }) {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const orderMarkerRef = useRef(null);
  const driverMarkerRef = useRef(null);
  const hasInitializedBounds = useRef(false);

  // Initialize map
  useEffect(() => {
    if (!mapContainerRef.current || mapRef.current || !order) return;

    // Create map
    const map = L.map(mapContainerRef.current, {
      center: [order.latitude, order.longitude],
      zoom: 15,
      zoomControl: false,
    });
    mapRef.current = map;

    // Add tile layer
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(map);

    // Create yellow/gold icon for pickup point
    const pickupIcon = L.icon({
      iconUrl: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });

    // Add order marker
    const orderMarker = L.marker([order.latitude, order.longitude], {
      icon: pickupIcon,
      title: 'Punto de Recojo',
    })
      .bindPopup(`<h3>${order.customer_name}</h3>`)
      .addTo(map);
    
    orderMarkerRef.current = orderMarker;

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [order]);

  // Update driver marker
  useEffect(() => {
    if (!mapRef.current || !driver?.latitude || !driver?.longitude) return;

    const driverIcon = L.icon({
      iconUrl: `${process.env.PUBLIC_URL}/logo.png`,
      iconSize: [30, 30],
      iconAnchor: [15, 30],
      popupAnchor: [0, -30],
    });

    if (driverMarkerRef.current) {
      // Update existing marker position
      driverMarkerRef.current.setLatLng([driver.latitude, driver.longitude]);
    } else {
      // Create new driver marker
      const driverMarker = L.marker([driver.latitude, driver.longitude], {
        icon: driverIcon,
        title: 'Mi Ubicación',
      }).addTo(mapRef.current);
      
      driverMarkerRef.current = driverMarker;
    }

    // Only center map to show both markers on FIRST render
    if (orderMarkerRef.current && driverMarkerRef.current && !hasInitializedBounds.current) {
      const bounds = L.latLngBounds([
        [driver.latitude, driver.longitude],
        [order.latitude, order.longitude]
      ]);
      mapRef.current.fitBounds(bounds, { padding: [50, 50] });
      hasInitializedBounds.current = true;
    }
  }, [driver, order]);

  return (
    <div 
      ref={mapContainerRef} 
      className="absolute inset-0 w-full h-full"
      style={{ zIndex: 0 }}
    />
  );
}